/**
 * Created by tdunham on 6/29/2017.
 */


export class Tag {

	public id:              number;             // The ID number of this tag in the Angular2 database.
	public tag:             string;             // The name of the tag ("injured").
	public checked:         number = 0;         // 1 = checked, 0 = not checked.
	public sport_checkbox:  boolean = false;    // Is this tag one from the active Sport's checkbox list?

	constructor( values: Object = {} ) {
		Object.assign( this, values );
	}

}



// WEBPACK FOOTER //
// ./src/app/services/tag/tag.ts